@if (navigationView) {
	<div class="navigation workspace">
		<ng-template component-loader [view]="navigationView" />
	</div>
}
<div class="workspace">
	@for (view of activeViews; track identifyView(view)) {
		<ng-template component-loader [view]="view" />
	}
</div>
@if (popupViews.length > 0) { <div class="popup-overlay"></div> }
@for (popupView of popupViews; track popupView; let i = $index) {
	<div class="popup-container">
		<popup-panel [view]="popupView" />
	</div>
}
